import styled from 'styled-components/native';

import { LargeProgressButton } from '../../base_ui';

export const StyledLargeProgressButton = styled(LargeProgressButton)`
  align-self: center;
`;
